import { createApp } from 'vue'
import App from './App.vue'

// import $ from 'jquery';
import '@/assets/main.css'
import './registerServiceWorker'

createApp(App).mount('#app')
